import { render } from "./domiciliation-salaire.vue?vue&type=template&id=6dcae466"
import script from "./domiciliation-salaire.vue?vue&type=script&lang=js"
export * from "./domiciliation-salaire.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__